module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_CEDD.aa2442b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_CEDD.png
// module id = 49
// module chunks = 0